import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const CardStackLoadable = loadable(() => import('./CardStack'), {
  resolveComponent: components => components.CardStack
});

export const CardStack = WithLazyHydration(CardStackLoadable, {
  name: 'CardStack'
});
